import get from 'lodash/get';
import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  CANCEL_BOOKING,
  CANCEL_BOOKING_ERROR,
  CANCEL_BOOKING_SUCCESS,
  VERIFY_MODIFY_BOOKING,
  VERIFY_MODIFY_BOOKING_ERROR,
  VERIFY_MODIFY_BOOKING_SUCCESS,
  VIEW_APPOINTMENTS,
  VIEW_APPOINTMENTS_ERROR,
  VIEW_APPOINTMENTS_SUCCESS,
  VIEW_GET_OTP,
  VIEW_GET_OTP_ERROR,
  VIEW_GET_OTP_SUCCESS,
} from '../type';

export const initialState = {
  patient: {
    loading: false,
    error: '',
    data: null,
  },
  appointments: {
    loading: false,
    error: '',
    data: null,
  },
  verifyModifyBooking: {
    loading: false,
    error: '',
    data: null,
  },
  cancel: {
    loading: false,
    error: '',
    data: null,
  },
  reschedule: {
    loading: false,
    error: '',
    data: null,
  },
};

const viewReducer = handleActions(
  new Map([
    [
      VIEW_GET_OTP,
      state => {
        return update(state, {
          patient: {
            loading: { $set: true },
            error: { $set: '' },
          },
          appointments: {
            loading: { $set: true },
            error: { $set: '' },
          },
          cancel: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      VIEW_GET_OTP_ERROR,
      (state, action) => {
        return update(state, {
          patient: {
            loading: { $set: false },
            error: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      VIEW_GET_OTP_SUCCESS,
      (state, action) => {
        return update(state, {
          patient: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      VIEW_APPOINTMENTS,
      state => {
        return update(state, {
          appointments: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      VIEW_APPOINTMENTS_ERROR,
      (state, action) => {
        return update(state, {
          appointments: {
            loading: { $set: false },
            error: {
              $set: get(action.payload, 'message', ''),
            },
          },
        });
      },
    ],
    [
      VIEW_APPOINTMENTS_SUCCESS,
      (state, action) => {
        return update(state, {
          appointments: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
    [
      VERIFY_MODIFY_BOOKING,
      state => {
        return update(state, {
          cancel: {
            loading: { $set: false },
            error: { $set: '' },
          },
          reschedule: {
            loading: { $set: false },
            error: { $set: '' },
          },
          verifyModifyBooking: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      VERIFY_MODIFY_BOOKING_SUCCESS,
      state => {
        return update(state, {
          verifyModifyBooking: {
            loading: { $set: false },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      VERIFY_MODIFY_BOOKING_ERROR,
      (state, action) => {
        return update(state, {
          verifyModifyBooking: {
            loading: { $set: false },
            error: { $set: get(action.payload, 'message', '') },
          },
        });
      },
    ],
    [
      CANCEL_BOOKING,
      state => {
        return update(state, {
          cancel: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      CANCEL_BOOKING_ERROR,
      (state, action) => {
        return update(state, {
          cancel: {
            loading: { $set: false },
            error: {
              $set: get(action.payload, 'message', ''),
            },
          },
        });
      },
    ],
    [
      CANCEL_BOOKING_SUCCESS,
      (state, action) => {
        return update(state, {
          cancel: {
            loading: { $set: false },
            data: {
              $set: action.payload,
            },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default viewReducer;
